/*** IMPORTS FROM imports-loader ***/


var implementation = require('./implementation');

module.exports = Function.prototype.bind || implementation;




//////////////////
// WEBPACK FOOTER
// ../~/function-bind/index.js
// module id = 17
// module chunks = 3